import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AlertComponent } from './alert.component'
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { TranslateModule } from '@ngx-translate/core'

@NgModule({
  declarations: [AlertComponent],
  imports: [
    CommonModule,
    SweetAlert2Module.forRoot(),
    ContentEditableModule,
    TranslateModule,
  ],
  exports: [AlertComponent],
})
export class AlertModule {}
